export default __webpack_public_path__ + "img/dwwvLcjq.80a17bce.svg";